module.exports = __webpack_public_path__ + "static/media/fish.9d5ae0c5.png";